import React, { useState, useEffect } from "react"
import { useAppCtx, appStore } from "lib/state"
import { Modal } from "lib/components"
import { cn } from "lib/utils"
import { evaluateConditionalItem } from "lib/utils/conditionals"
import { Forms } from "lib/components/forms"
import { useConditional } from "lib/units/conditional"

import {rp1} from "lib/utils/testapi/rp1.js"
import {rp2} from "lib/utils/testapi/rp2" 
import {merch1} from "lib/utils/testapi/merch1"

const testdocs = [
  { id: "rp1", type: "rp", name: "RP 1", description: "Features three products, multiple documents, and most key values filled in. A good, general, all-purpose test doc.", data: rp1},
  
  { id: "rp2", type: "rp", name: "RP 2", description: "Same as RP 1, except there are no products or documents.", data: rp2},

  { id: "merch1", type: "merch", name: "MERCH 1", description: "Standard Merchant API data with most key fields filled in.", data: merch1 },
]

export default function TestConditionalModal(){

  const { appState }:any = useAppCtx()
  const { store, AppStore }:any = appStore()
  const { closeModal } = useConditional()

  // const { currentConditional, updateConditional }:any = useConditionalCtx()
  const { update }:any = AppStore 

  const [ selectedTestDocs, setSelectedTestDocs ] = useState<any>({ rp: null, merch:null })
  const [ testResults, setTestResults ] = useState<any>(null)

  const runTest = () => {
    // console.log(currentConditional.items)
    // let results:any[] = [] 
    // const clientApiData = {
    //   rp: testdocs?.find( (doc:any) => doc.id === selectedTestDocs.rp )?.data || null,
    //   merchant: testdocs?.find( (doc:any) => doc.id === selectedTestDocs.merch )?.data || null
    // }
    // currentConditional.items.forEach( (item:any) => {
    //   const result = evaluateConditionalItem(clientApiData, item)
    //   results = [...results, { item, result }]
    // })
    // console.log("Test Results: ", results)
    // setTestResults(results)
  }

  const parseDataResult = (data:any) => {
    if( data === null || data === undefined ) return "null"
    if( typeof data === "object" && !Array.isArray(data) ) return JSON.stringify(data, null, 2)
    if( Array.isArray(data) ) return data.join(", ")
    return data.toString()
  }


  return (
    <Modal
      size="2xl"
      title="Test Conditional:" 
      status={store.metas.conditionalModal === "test-conditional" ? "open" : "closed"}
      onClose={closeModal}
    >
      <div className="w-full mx-auto flex flex-col  items-center gap-4">

        <p className="px-2">We have several prepared test API documents you can use to verify if your conditional statements are properly expressed. Choose the test docs you wish to use then click the test button. This testing console only tests each conditional statement in isolation.</p>

        <div className="w-full flex gap-4">

          <div className="w-4/12 flex flex-col gap-2">
            { testdocs.map( (doc:any) => (
              <div 
                key={doc.id} 
                onClick={() => setSelectedTestDocs({ ...selectedTestDocs, [doc.type]: doc.id })}
                className={cn(
                  "w-full flex flex-col border-2 border-solid text-xs cursor-pointer",
                  selectedTestDocs[doc.type] === doc.id ? "border-teal-800" : "border-slate-700")}
              >
                <div className="w-full h-8 flex items-center bg-slate-700 text-neutral-100 border-b border-solid border-white/500 px-2 text-sm">
                  <span>{ doc.name }</span>
                </div>
                <div className="w-full p-2">
                  <span>{ doc.description }</span>
                </div>
              </div>
            ))}
          </div>

          <div className="w-8/12 flex flex-col gap-2 max-h-[30rem] overflow-y-hidden">
            <button
              onClick={runTest} 
              className="w-full h-8 bg-teal-800 text-neutral-100 text-xs uppercase flex justify-center items-center"
            >
              run test
            </button>

            <div className="w-full flex flex-col gap-2 p-2 border border-solid border-slate-700 overflow-y-auto scrollbar">
              { testResults?.map( (resultObj:any) => (
                <div key={resultObj.item.refid} className="w-full flex flex-col">
                  <p>{ resultObj.item.alias }</p>
                  <p>Expected: { resultObj.item.operator } { resultObj.item.value }</p>
                  <p>Found: { parseDataResult(resultObj.result.data) }</p>
                  <p>Verdict: { resultObj.result.verdict === true ? "PASS" : "FAIL" }</p>
                </div>
              ))}
            </div>
          </div>

        </div>

      </div>
    </Modal>
  )
}